import { faBowlFood } from '@fortawesome/pro-regular-svg-icons/faBowlFood';
import { faSuitcaseMedical } from '@fortawesome/pro-regular-svg-icons/faSuitcaseMedical';
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons/faClipboardList';
import { faSuitcase } from '@fortawesome/pro-regular-svg-icons/faSuitcase';
import { faBoxOpen } from '@fortawesome/pro-regular-svg-icons/faBoxOpen';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Period } from '@spike/model';
import PrivatePage from 'pages/PrivatePage';
import moment from 'moment-timezone';
import { FunctionComponent, useState } from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { TasksBelongingsPath, TasksFeedingPath, TasksMedsPath, TasksOpsPath, TasksPath } from 'routes/Paths';
import TaskCategoryDashboard from './Dashboard/TaskCategoryDashboard';
import OpsTasks from './Ops/OpsTasks';
import Belongings from './Belongings/Belongings';
import { TASKS_TITLE_ACTIONS_ID } from './TasksTitlePortal';
import styles from './TasksLayout.module.scss';

export type TasksDatePeriod = Period & { name?: string };

const defaultDatePeriod = (): TasksDatePeriod => ({
    from: moment().startOf('day'),
    to: moment().endOf('day'),
    name: 'Today'
});

export const TasksLayout: FunctionComponent = () => {
    const [datePeriod, setDatePeriod] = useState<TasksDatePeriod>(defaultDatePeriod);

    const handleChangeDate = (period: TasksDatePeriod) => {
        setDatePeriod({
            from: period.from.clone(),
            to: period.to.clone(),
            ...(period.name ? { name: period.name } : {})
        });
    };

    return (
        <PrivatePage
            pageName="/tasks"
            title="Tasks - Cuddles"
        >
            <div className={styles.container}>
                <div className={styles.mobileTitleRow}>
                    <p className={styles.mobileTitle}>Tasks</p>
                    <div
                        className={styles.mobileTitleActions}
                        id={TASKS_TITLE_ACTIONS_ID}
                    />
                </div>

                <div className={styles.navbar}>
                    <p className={styles.title}>Tasks</p>

                    <nav className={styles.menu}>
                        <NavLink
                            to={TasksFeedingPath}
                            className={styles.menuLink}
                        >
                            <FontAwesomeIcon icon={faBowlFood} />
                            Feeding
                        </NavLink>
                        <NavLink
                            to={TasksMedsPath}
                            className={styles.menuLink}
                        >
                            <FontAwesomeIcon icon={faSuitcaseMedical} />
                            Meds
                        </NavLink>
                        <NavLink
                            exact
                            to={TasksPath}
                            className={styles.menuLink}
                        >
                            <FontAwesomeIcon icon={faClipboardList} />
                            Tasks
                        </NavLink>
                        <NavLink
                            to={TasksBelongingsPath}
                            className={styles.menuLink}
                        >
                            <FontAwesomeIcon icon={faBoxOpen} />
                            Belongings
                        </NavLink>
                        <NavLink
                            to={TasksOpsPath}
                            className={styles.menuLink}
                        >
                            <FontAwesomeIcon icon={faSuitcase} />
                            Ops
                        </NavLink>
                    </nav>
                </div>

                <div className={styles.content}>
                    <Switch>
                        <Route path={TasksFeedingPath}>
                            <TaskCategoryDashboard
                                key="feeding"
                                category="feeding"
                                datePeriod={datePeriod}
                                onChangeDate={handleChangeDate}
                            />
                        </Route>
                        <Route path={TasksMedsPath}>
                            <TaskCategoryDashboard
                                key="medication"
                                category="medication"
                                datePeriod={datePeriod}
                                onChangeDate={handleChangeDate}
                            />
                        </Route>
                        <Route path={TasksOpsPath}>
                            <OpsTasks
                                datePeriod={datePeriod}
                                onChangeDate={handleChangeDate}
                            />
                        </Route>
                        <Route path={TasksBelongingsPath}>
                            <Belongings
                                datePeriod={datePeriod}
                                onChangeDate={handleChangeDate}
                            />
                        </Route>
                        <Route
                            exact
                            path={TasksPath}
                        >
                            <TaskCategoryDashboard
                                key="care"
                                category="care"
                                datePeriod={datePeriod}
                                onChangeDate={handleChangeDate}
                            />
                        </Route>
                    </Switch>
                </div>
            </div>
        </PrivatePage>
    );
};

export default TasksLayout;
